import React from 'react'

function SoldeCard({ solde, typeCarte, cardNo }) {
  return (
    <div className="solde-carte">
      <h3>info sur la carte </h3>
      <p><strong>Numéro carte :</strong> {cardNo}</p>
      <p><strong>Type de carte :</strong> {typeCarte}</p>
      <p><strong>Solde disponible :</strong> {solde} FCFA</p>
    </div>
  )
}

export default SoldeCard